import {
  Autocomplete,
  Button,
  Checkbox,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import { addSupplierSchema } from "dashboard/schemas";
import ReactQuill from "react-quill";
import { Field, Form, Formik } from "formik";
import React from "react";
import * as Yup from "yup";
import {
  CheckBox as CheckboxIcon,
  CheckBoxOutlineBlank,
  CloudUpload,
} from "@mui/icons-material";
import { uploadFile } from "utils";
import Swal from "sweetalert2";
import { db } from "hooks";

const AddSupplier = () => {
  const [imagePreview, setImagePreview] = React.useState(null);
  const [autoCompleteValues, setAutoCompleteValues] = React.useState([]);

  const initialValues = addSupplierSchema?.reduce(
    (accumulator, currentValue) => {
      accumulator[currentValue.name] = currentValue.initialValue;
      return accumulator;
    },
    {}
  );
  const validationSchema = addSupplierSchema.reduce(
    (accumulator, currentValue) => {
      accumulator[currentValue.name] = currentValue.validationSchema;
      return accumulator;
    },
    {}
  );

  const handleSubmit = async (values, submitProps) => {
    try {
      // console.log("submit");
      // console.log(values);

      const supplierData = {
        ...values,
        rating: 0,
        reviews: 0,
        createdAt: Date.now(),
        totalSales: 0,
      };

      await db.pushData("suppliers", supplierData);
      Swal.fire({
        title: "Success",
        text: "Supplier added successfully",
        icon: "success",
      });
      submitProps.resetForm();
      setImagePreview(null);
      setAutoCompleteValues([]);
    } catch (error) {
      console.log(error);
      Swal.fire({
        title: "Error",
        text: "Something went wrong",
        icon: "error",
      });
    }
  };

  const handleUpload = async (e) => {
    try {
      console.log("running");
      const file = e.target.files[0];

      const url = URL.createObjectURL(file);

      setImagePreview(url);

      // console.log(url);

      const date = Date.now();

      const path = `/suppliers/images/${date}`;

      if (!file) {
        return;
      }

      const downLoadUrl = await uploadFile({ path, file });

      return downLoadUrl;
    } catch (error) {
      console.log(error);
      return null;
    }
  };

  return (
    <main className="dashboard-add-supplier-main">
      <div className="add-supplier-title">Add Supplier</div>
      <Formik
        enableReinitialize
        initialValues={{
          ...initialValues,
        }}
        validationSchema={Yup.object(validationSchema)}
        onSubmit={handleSubmit}
      >
        {(formik) => (
          <Form className="auth-form-field">
            <Grid container spacing={4} justifyContent="center">
              <Grid item xs={12} sm={12} md={4}>
                <div className="flex-column align-item-start supplier-img  auth-input-form ">
                  <InputLabel> Image </InputLabel>
                  <div className="add-supplier-img  ">
                    <input
                      type="file"
                      name=""
                      id=""
                      onChange={async (e) => {
                        let url = await handleUpload(e);
                        formik.setFieldValue("image", url);
                      }}
                    />

                    {imagePreview ? (
                      <img src={imagePreview} alt="" />
                    ) : (
                      <div className="supplier-img-preview flex-column align-items-center gap-2 ">
                        <CloudUpload
                          sx={{
                            height: "3rem",
                            width: "3rem",
                          }}
                        />
                        <h3 className="supplier-upload-text">
                          Click to upload or drag and drop file here
                        </h3>
                      </div>
                    )}
                  </div>
                </div>
                <h3 className="supplier-error">
                  {formik.touched.image && formik.errors.image}
                </h3>
              </Grid>
              {/* {console.log(formik.errors.supplierType)} */}

              <Grid item xs={12} sm={12} md={8}>
                {addSupplierSchema?.map((inputItem) => (
                  <Grid
                    container
                    width={"100%"}
                    flex
                    spacing={2}
                    justifyContent="center"
                  >
                    <Grid item key={inputItem.key} xs={12} sm={12}>
                      <Field name={inputItem.name} key={inputItem.key}>
                        {(props) => (
                          <>
                            {inputItem?.type === "checkbox" ? (
                              <div className="flex-column align-item-start  auth-input-form ">
                                <InputLabel> {inputItem?.label} </InputLabel>
                                <Autocomplete
                                  value={autoCompleteValues}
                                  multiple
                                  fullWidth
                                  isOptionEqualToValue={(option, value) => {
                                    return option.label === value.label;
                                  }}
                                  options={[
                                    {
                                      value: "cash",
                                      label: "Cash",
                                    },
                                    {
                                      value: "card",
                                      label: "Card",
                                    },
                                  ]}
                                  onChange={(event, value) => {
                                    setAutoCompleteValues(value);
                                    let data = {
                                      cash: value.some(
                                        (item) => item?.value === "cash"
                                      ),
                                      card: value.some(
                                        (item) => item?.value === "card"
                                      ),
                                    };
                                    formik.setFieldValue(inputItem.name, data);
                                  }}
                                  disableCloseOnSelect
                                  getOptionLabel={(option) => option.label}
                                  renderOption={(
                                    props,
                                    option,
                                    { selected }
                                  ) => (
                                    <li {...props}>
                                      <Checkbox
                                        icon={
                                          <CheckBoxOutlineBlank fontSize="small" />
                                        }
                                        checkedIcon={
                                          <CheckboxIcon fontSize="small" />
                                        }
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                      />
                                      {option.label}
                                    </li>
                                  )}
                                  renderInput={(params) => (
                                    <TextField
                                      {...params}
                                      error={
                                        formik.errors.supplierType &&
                                        formik.touched.supplierType
                                      }
                                      placeholder=""
                                    />
                                  )}
                                />
                                <h3 className="supplier-error">
                                  {formik.touched.supplierType &&
                                    formik.errors.supplierType}
                                </h3>
                              </div>
                            ) : inputItem?.type === "select" ? (
                              <div className="flex-column  auth-input-form ">
                                <InputLabel> {inputItem?.label} </InputLabel>
                                <Select
                                  fullWidth
                                  value={formik.values[inputItem.name]}
                                  onChange={(e) => {
                                    formik.setFieldValue(
                                      inputItem.name,
                                      e.target.value
                                    );
                                  }}
                                  error={
                                    formik.errors[inputItem.name] &&
                                    formik.touched[inputItem.name]
                                  }
                                >
                                  <MenuItem value="">
                                    <em>Select</em>
                                  </MenuItem>
                                  <MenuItem value={"local"}>Local</MenuItem>
                                  <MenuItem value={"international"}>
                                    International
                                  </MenuItem>
                                  <MenuItem value={"quickDelivery"}>
                                    Quick Delivery
                                  </MenuItem>
                                </Select>
                                <h3 className="supplier-error">
                                  {formik.errors[inputItem.name]}
                                </h3>
                              </div>
                            ) : inputItem?.name === "info" ? (
                              <div className="flex-column  auth-input-form ">
                                <InputLabel> {inputItem?.label} </InputLabel>
                                <ReactQuill
                                  style={{
                                    height: "200px",
                                    width: "100%",
                                  }}
                                  value={formik.values.info}
                                  onChange={(value) => {
                                    formik.setFieldValue(inputItem.name, value);
                                  }}
                                />

                                <h3 className="supplier-error">
                                  {formik.touched[inputItem.name] &&
                                    formik.errors[inputItem.name]}
                                </h3>
                              </div>
                            ) : (
                              inputItem?.type !== "file" && (
                                <div className="flex-column  auth-input-form ">
                                  <InputLabel> {inputItem?.label} </InputLabel>
                                  <TextField
                                    fullWidth
                                    type={inputItem.type}
                                    rows={inputItem?.rows}
                                    error={Boolean(
                                      props.meta.touched && props.meta.error
                                    )}
                                    helperText={
                                      props.meta.touched && props.meta.error
                                    }
                                    {...props.field}
                                  />
                                </div>
                              )
                            )}
                          </>
                        )}
                      </Field>
                    </Grid>
                  </Grid>
                ))}
              </Grid>
            </Grid>

            <div className="w-100 flex-row justify-content-center">
              <Button type="submit" className="dashboard-save-btn">
                Save
              </Button>
            </div>
          </Form>
        )}
      </Formik>
    </main>
  );
};

export default AddSupplier;
